const viewToggle = () => {
    const viewToggleEl = document.getElementsByClassName('view-toggle__item:not(.--noscroll)');
    const viewToggleContent = document.getElementsByClassName('view-toggle__content');
    const viewToggleEvent = new Event('view-toggle-event', { "bubbles" : true });

    [].forEach.call(document.querySelectorAll('.view-toggle__item'), (el) =>{
        el.addEventListener('click', (e) => {
            for (var i = 0; i < viewToggleContent.length; i++) {
                viewToggleContent[i].style.display = "none";
            }

            for (var i = 0; i < viewToggleEl.length; i++) {
                viewToggleEl[i].classList.remove("active");
            }

            el.classList.add('active');

            var target = document.querySelector(el.getAttribute('data-target'));
            target.style.display = "block";  


            target.dispatchEvent(viewToggleEvent);

        });
    });
    
}
export default viewToggle;
